var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.offerBanners.length)?_c('div',{staticClass:"offer-promos"},_vm._l((_vm.offerBanners),function(banner){return _c('OfferDynamicBanner',{key:banner.id,attrs:{"banner":banner,"template":_vm.getBannerTemplate(banner.templateId)}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }